export const rphDecisionApprovalDefault = '{\n' +
    '    "profileId": ""\n' +
    '    "status": "APPROVED"\n' +
    '}';

export interface IRphDecisionApprovalRequest {
    profileId: string
    status: string
}
